resultCacheMaxSize